import { Badge } from '@optiaxiom/react';

type ExecutionStatusBadgeProps = {
  status: string;
  showAsRunning?: boolean;
};

export function ExecutionStatusBadge({ status, showAsRunning = false }: ExecutionStatusBadgeProps) {
  const displayStatus = showAsRunning && status.toLowerCase() === 'pending' ? 'Running' : status;

  const getStatusColor = () => {
    const lowerStatus = status.toLowerCase();
    if (lowerStatus === 'completed') {
      return 'success';
    } else if (lowerStatus === 'pending' || lowerStatus === 'running') {
      return 'warning';
    } else if (lowerStatus === 'cancelled') {
      return 'neutral';
    } else {
      return 'danger';
    }
  };
  return (
    <Badge intent={getStatusColor()}>
      {displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1).toLowerCase()}
    </Badge>
  );
}
